import type { RefObject } from "react";
import { useAnchoredPosition } from "components/designV2/useAnchoredPosition";
import type {
  TimePickerMenuPosition,
  TimePickerSize,
} from "./timePicker.types";

const COMPACT_MENU_MIN_WIDTH_PX = 240;
const MENU_VERTICAL_OFFSET_PX = 4;

export interface UseTimePickerMenuPositionProps {
  readonly floatingRef: RefObject<HTMLDivElement>;
  readonly isOpen: boolean;
  readonly size: TimePickerSize;
  readonly triggerRef: RefObject<HTMLDivElement>;
}

export const useTimePickerMenuPosition = (
  props: UseTimePickerMenuPositionProps,
): TimePickerMenuPosition | null => {
  return useAnchoredPosition({
    floatingRef: props.floatingRef,
    gap: MENU_VERTICAL_OFFSET_PX,
    isOpen: props.isOpen,
    minWidth: props.size === "compact" ? COMPACT_MENU_MIN_WIDTH_PX : undefined,
    placement: props.size === "compact" ? "end" : "start",
    triggerRef: props.triggerRef,
  });
};
